import { createAction, createReducer } from "@reduxjs/toolkit"
import { toaster } from "components/common/Toast"

const received = createAction("success/received")

const initialState = {
  message: ""
}

const successReducer = createReducer(initialState, {
  [received.type]: (_, { payload }) => {
    const message = payload?.data?.message
    if (message && typeof message === "string") {
      toaster.success({ title: message })
    }
  }
})

export default successReducer

export { received as receiveSuccess }
